import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { memo } from 'react';
import styled from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	className?: string;
	icon: PredefinedIcons;
	text: string;
	onClick?: () => void;
	isSelected?: boolean;
	'data-testid'?: string;
}

const PearBox = ({ className, text, icon, onClick, 'data-testid': dataTestId }: Props) => {
	return (
		<div className={className} onClick={onClick} data-testid={dataTestId}>
			<Icon size="lg" variant={icon} />
			<Text variant="sans/11/600" disableVariantMapping>
				{text}
			</Text>
		</div>
	);
};

const Memoized = memo(PearBox);
const Styled = styled(Memoized)`
	display: flex;
	align-items: center;
	box-sizing: border-box;
	height: 3rem;
	width: 15rem;
	border: 1px solid var(--borderColor);
	padding: 1em;

	background-color: ${({ theme, isSelected }) =>
		isSelected ? theme.v2.color.secondary[200] : theme.v2.color.neutral[200]};

	--borderColor: ${({ theme, isSelected }) =>
		isSelected ? theme.v2.color.secondary[800] : theme.v2.color.neutral[300]};

	${Text} {
		margin-left: 0.5em;
		color: ${({ theme }) => theme.v2.color.neutral[1200]};
		opacity: 0.8;
	}
	${Icon} {
		opacity: 0.8;
	}
`;

export { Styled as PearBox };
